<template>
  <div class="jobAdd">
    <el-dialog
      title="新增证书和等级"
      :visible.sync="visible"
      width="500px"
      :close-on-click-modal="false"
      class="jobDialog"
      :before-close="handleCloseDialog"
      :show-close="false"
      top="25vh"
      :lock-scroll="false"
    >
      <div class="main">
        <el-input
          v-model="jobName"
          placeholder="新增证书名称"
          clearable
          class="input-width"
        ></el-input>
        <div class="checkbox">
          <el-checkbox-group v-model="levelList">
            <el-checkbox label="一级"></el-checkbox>
            <el-checkbox label="二级"></el-checkbox>
            <el-checkbox label="三级"></el-checkbox>
            <el-checkbox label="四级"></el-checkbox>
            <el-checkbox label="五级"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmitFn">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { jobAdd } from '@/api/apply'
import to from 'await-to'
export default {
  data() {
    return {
      visible: false,
      jobName: '',
      levelList: [],
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    async handleSubmitFn() {
      if (!this.jobName) return this.$message.warning('请输入证书名称')
      if (this.levelList.length == 0) return this.$message.warning('请选择证书等级')
      const [, err] = await to(jobAdd({ jobName: this.jobName, levelList: this.levelList }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$emit('success')
      this.visible = false
      this.jobName = ''
      this.levelList = []
    },
    handleCloseDialog() {
      this.visible = false
      this.jobName = ''
      this.levelList = []
    },
  },
}
</script>
<style lang="scss" scoped>
.jobDialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 30px 40px;
      .checkbox {
        margin-top: 30px;
      }
    }
  }
}
</style>
